"use client";

import { SingleProduct } from "@/__generated__/graphql";
import ShareIcon from "@/app/_components/Icons/ShareIcon";
import { IconButton } from "@mui/material";
import React, { useState } from "react";
import { webEnv } from "@/environment/environment";

type Props = {
  product: SingleProduct;
};
export default function ShareProduct({ product }: Props) {
  const [currentUrl, setCurrentUrl] = useState(`${webEnv.siteUrl}products/${product.code}/${product.title.replaceAll(" ", "-")}`);

  const handleShare = async () => {
    if (!navigator.share) {
      alert("مرورگر شما از قابلیت اشتراک‌گذاری پشتیبانی نمی‌کند.");
      return;
    }

    try {
      if (navigator.canShare?.({ url: currentUrl }))
        await navigator.share({
          title: product.title,
          text: `مشاهده محصول: ${product.title}`,
          url: currentUrl,
        });
    } catch (error) {
      console.log("Share cancelled or failed:", error);
    }
  };
  return (
    <>
      <IconButton
        aria-label="اشتراک‌گذاری"
        onClick={(event) => {
          event.stopPropagation();
          handleShare();
        }}
        sx={{
          width: { xs: 35, xsm: 38, md: 40 },
          height: { xs: 35, xsm: 38, md: 40 },
          backgroundColor: "rgba(255,255,255,0.8)",
          boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
          "&:hover": { backgroundColor: "#fff" },
        }}
      >
        <ShareIcon />
      </IconButton>
    </>
  );
}
